import "../styles/ticket-buy.css";
import { useState, useEffect, useRef } from "react";
import OffPlusController from "../services/offplus-controller";
import { Skeleton } from "primereact/skeleton";
import { PrimeIcons } from "primereact/api";
import { getToken } from "../utility";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";

export default function TicketBuy(props) {
	const offPlusController = new OffPlusController();
	const [isLoading, setIsLoading] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [errorData, setErrorData] = useState("");
	const [productModel, setProductModel] = useState({});
	const [quantity, setQuantity] = useState(1);
	const mapRef = useRef(null);
	//
	useEffect(() => {
		getData();
	}, []);

	const getData = async function () {
		try {
			if (!getToken()) return;
			setIsLoading(true);
			let productModelId = "";
			if (window.location.href.indexOf("?") > 0) {
				let urlParams = new URLSearchParams(window.location.href.split("?")[1]);
				productModelId = urlParams.get("id");
			}
			const serviceResult = await offPlusController.getActiveProductModel(
				productModelId
			);
			if (serviceResult.isSuccess === false) throw serviceResult.message;
			setProductModel(serviceResult.value);
		} catch (error) {
			setErrorData(error.toString());
		}
		setIsLoading(false);
	};

	//> changeQuantity
	const changeQuantity = function (value) {
		let newValue = quantity + value;
		if (newValue < 1) newValue = 1;
		if (newValue > 50) newValue = 50;
		setQuantity(newValue);
	};

	//> createOrder
	const createOrder = async function () {
		try {
			setIsSaving(true);
			let createServiceOrderResult = await offPlusController.createOrder(
				productModel.productModelId,
				quantity
			);
			if (createServiceOrderResult.isSuccess === false)
				throw createServiceOrderResult.message;
			window.location = createServiceOrderResult.value;
		} catch (error) {
			setErrorMessage(error.toString());
		} finally {
			setIsSaving(false);
		}
	};
	//>

	if (!getToken()) {
		let code = "";
		if (window.location.href.indexOf("?") > 0) {
			let urlParams = new URLSearchParams(window.location.href.split("?")[1]);
			code = urlParams.get("code");
		}
		window.location = "/#/login?returnUrl=/ticket-home";
		return <></>;
	}
	return (
		<div>
			{isLoading === true && (
				<>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-12"></Skeleton>
					</div>
				</>
			)}

			{isLoading === false && (
				<>
					{errorMessage && <Message severity="warn" text={errorMessage} />}
					<ul className="ticket-buy">
						<li>
							<label>نام مجموعه ورزشی</label>
							<i></i>
							<b>{productModel.storeName}</b>
						</li>
						<li>
							<label>نوع خدمات</label>
							<i></i>
							<b>
								{productModel.productName} : {productModel.modelName}
							</b>
						</li>
						<li>
							<label>قیمت خدمات</label>
							<i></i>
							<b>
								{productModel.unitCost?.toLocaleString("fa-IR") + " ریال "}{" "}
							</b>
						</li>
						<li>
							<label>تعداد</label>
							<i></i>
							<div>
								<Button onClick={() => changeQuantity(-1)} severity="danger">
									<i className={PrimeIcons.MINUS}></i>
								</Button>
								<InputText
									value={quantity}
									onChange={(e) => setQuantity(e.target.value)}
									readOnly={true}
								/>
								<Button onClick={() => changeQuantity(1)} severity="success">
									<i className={PrimeIcons.PLUS}></i>
								</Button>
							</div>
						</li>
						<li>
							<label>مجموع قیمت</label>
							<i></i>
							<b>
								{(productModel.unitCost * quantity).toLocaleString("fa-IR") +
									" ریال "}{" "}
							</b>
						</li>
						{productModel.offPercent > 0 && (
							<>
								<li>
									<label> - {productModel.offPercent} درصد تخفیف</label>
									<i></i>
									<b>
										{(
											productModel.unitCost *
											quantity *
											productModel.offPercent *
											0.01
										).toLocaleString("fa-IR") + " ریال "}
									</b>
								</li>
							</>
						)}
						<li>
							<label> = مبلغ پرداختی</label>
							<i></i>
							<b>
								{(
									productModel.unitCost * quantity -
									productModel.unitCost *
										quantity *
										productModel.offPercent *
										0.01
								).toLocaleString("fa-IR") + " ریال "}
							</b>
						</li>
						<li>
							<label></label>
							<span></span>
							<Button
								severity="success"
								disabled={isSaving}
								onClick={() => createOrder()}
							>
								پرداخت آنلاین
							</Button>
						</li>
					</ul>
				</>
			)}
		</div>
	);
}
